import React from "react";
import "./PoliticaPrivacidad.css";

const effectiveDate = "3 de septiembre de 2026";

export default function TerminosUso() {
  return (
    <main className="privacy-page">
      <section className="privacy-hero">
        <a className="privacy-brand" href="/login" aria-label="Ir al inicio de MozzoApp">
          mozzo<span>app</span>
        </a>
        <p className="privacy-kicker">TERMINOS DEL SERVICIO</p>
        <h1>Terminos de uso de MozzoApp</h1>
        <p className="privacy-lead">
          Estas condiciones regulan el acceso y uso de la plataforma de gestion
          gastronomica MozzoApp y sus modulos asociados.
        </p>
        <p className="privacy-date">Vigentes desde el {effectiveDate}.</p>
      </section>

      <article className="privacy-content">
        <section>
          <h2>1. Titular del servicio</h2>
          <p>
            MozzoApp es operada por <strong>PORTILLO DIEGO ALBERTO</strong>, bajo
            el nombre comercial MozzoApp. Para consultas sobre estas condiciones
            puede escribir a <a href="mailto:privacidad@mozzoapp.com">privacidad@mozzoapp.com</a>.
          </p>
        </section>

        <section>
          <h2>2. Aceptacion y cuentas</h2>
          <p>
            Al registrarse o utilizar MozzoApp, el usuario declara tener capacidad
            para aceptar estas condiciones. Cada restaurante es responsable de la
            exactitud de sus datos, de proteger sus credenciales y de autorizar al
            personal que accede a su cuenta.
          </p>
        </section>

        <section>
          <h2>3. Condiciones para Riders</h2>
          <p>
            Para registrarse y operar como Rider es obligatorio tener 18 anos o mas,
            informar datos propios y verdaderos, y presentar la documentacion que
            corresponda al medio de reparto utilizado. La cuenta no queda habilitada
            hasta que MozzoApp complete una revision manual de identidad y
            documentacion.
          </p>
          <p>
            El Rider autoriza el tratamiento de su DNI, selfie, resultado de prueba de
            vida y, cuando corresponda, licencia y cedula del vehiculo para validar la
            identidad, prevenir fraude y proteger las entregas. Una presentacion puede
            ser observada, rechazada o requerir nuevas fotografias cuando no sea clara,
            este vencida o no permita comprobar que pertenece a la misma persona.
          </p>
        </section>

        <section>
          <h2>4. Alcance de la plataforma</h2>
          <p>
            MozzoApp ofrece herramientas para administrar sucursales, menus,
            pedidos, cocina, salon, stock, pagos, delivery y comunicaciones. Los
            modulos disponibles pueden variar segun la configuracion contratada o
            habilitada por cada restaurante.
          </p>
        </section>

        <section>
          <h2>5. Responsabilidad del restaurante</h2>
          <p>
            El restaurante conserva la responsabilidad por sus productos, precios,
            promociones, disponibilidad, informacion comercial, cumplimiento fiscal,
            preparacion, calidad, entrega y atencion al cliente. Tambien debe respetar
            la normativa aplicable a su actividad y a la proteccion de consumidores.
          </p>
        </section>

        <section>
          <h2>6. Pedidos, pagos e integraciones</h2>
          <p>
            Los pedidos y pagos pueden procesarse mediante servicios de terceros,
            como Mercado Pago o WhatsApp Business. El uso de esas integraciones esta
            sujeto tambien a las condiciones del proveedor correspondiente. MozzoApp
            registra referencias operativas, pero no almacena datos completos de tarjetas.
          </p>
        </section>

        <section>
          <h2>7. Uso permitido</h2>
          <p>
            No se permite utilizar la plataforma para actividades ilegales, acceder
            a cuentas ajenas, vulnerar medidas de seguridad, enviar comunicaciones no
            autorizadas o interferir con el funcionamiento del servicio. MozzoApp
            puede restringir o suspender accesos ante fraude, abuso o incumplimiento.
          </p>
        </section>

        <section>
          <h2>8. Disponibilidad y soporte</h2>
          <p>
            Trabajamos para mantener el servicio disponible y seguro, aunque pueden
            existir interrupciones por mantenimiento, conectividad o servicios de
            terceros. Los incidentes se atienden con criterios razonables de prioridad
            y continuidad operativa.
          </p>
        </section>

        <section>
          <h2>9. Propiedad intelectual</h2>
          <p>
            MozzoApp, su software, identidad visual y contenidos propios pertenecen a
            su titular o a sus licenciantes. El restaurante mantiene la titularidad y
            responsabilidad sobre las marcas, imagenes, menus y datos que incorpora.
          </p>
        </section>

        <section>
          <h2>10. Privacidad y eliminacion</h2>
          <p>
            El tratamiento de datos se describe en la
            <a href="/politica-de-privacidad"> Politica de privacidad</a>. Las
            instrucciones para solicitar la eliminacion de datos estan disponibles en
            <a href="/eliminacion-de-datos"> Eliminacion de datos</a>.
          </p>
        </section>

        <section>
          <h2>11. Cambios y legislacion aplicable</h2>
          <p>
            Estas condiciones pueden actualizarse para reflejar cambios legales o del
            servicio. La version vigente se publicara en esta pagina. Se aplican las
            leyes de la Republica Argentina, sin afectar los derechos inderogables que
            correspondan a consumidores o usuarios.
          </p>
        </section>
      </article>
    </main>
  );
}
